export default {"src":"/_next/static/media/WhatsappFooter.9d622e1f.svg","height":100,"width":100,"blurWidth":0,"blurHeight":0};